<template>
  <div class="w-full vx-coll-fixed-height">
    <div class="vx-col w-full">
      <div class="vx-row">
        <div class="vx-col w-full">
          <label class="vs-input--label">{{ $t('sections.prosecution.dataForm.fileName') }} <small>(สามารถแนบไฟล์ได้ไม่จำกัด .jpg .jpeg .png .pdf .xlsx .xls .csv .doc .docx)</small></label>
          <vs-input type="text" class="w-full mb-2" v-model="form.description" />
          <input type="file" @change="onFileChange" ref="inputFile" accept=".jpg, .jpeg, .png, .pdf, .xlsx, .xls, .csv, .doc, .docx" />
          <vs-button class="btn-icon float-right mr-3" size="small" color="success" :disabled="!selectedFile || !form.description" @click="onUploadFile">เพิ่ม</vs-button>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-divider position="left" class="mb-0"></vs-divider>
          <vs-list>
            <vs-list-item v-for="file in form.files" :key="file.id" :title="file.description" >
              <vs-button type="line" line-origin="left" color="success" size="small" @click="download(file)" :disabled="!file.fileName">เรียกดู</vs-button>
              <vs-button class="btn-icon" size="small" color="danger" @click="del(file.id)" v-if="visibilityDel(file)">ลบ</vs-button>
            </vs-list-item>
          </vs-list>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getUploadsUrl} from "@/utils/upload";
import {IFileFrom} from "@/constants/interface";
import {createNamespacedHelpers} from "vuex";
import DividerDefault from "@/views/components/vuesax/divider/DividerDefault.vue";
import {ValidationProvider} from "vee-validate";
import flatPickr from "vue-flatpickr-component";

const {mapActions: mapProsecutionActions, mapState: mapProsecutionState} = createNamespacedHelpers('Prosecution')

export default {
  name: "FileInfoTab",
  components: {
    DividerDefault,
    ValidationProvider,
    flatPickr,
  },
  props: {},
  data () {
    return {
      form:{
        files: []
      },
      selectedFile: null,
      reportServer: process.env.VUE_APP_REPORT_SERVER
    }
  },
  computed: {
    ...mapProsecutionState(['prosecution']),
    currentUser () {
      if(!this.$store.state.currentUser){
        return null
      }
      return {
        id: this.$store.state.currentUser.id,
        email: this.$store.state.currentUser.email,
        role: this.$store.state.currentUser.role
      }
    },
    isRoot(){
      if(!this.currentUser){
        return false
      }
      const { isRoot } = this.currentUser.role
      return isRoot
    },
    _prosecution() {
      if(!this.prosecution) return null
      return {
        ...this.prosecution
      }
    },
  },
  async created () {
    const vm = this;
    if(this.prosecution){
      vm.form = {
        files: this.prosecution.files.map(file => {
          return {
            id: file.id,
            description: file.description,
            fileName: file.fileName,
            fileType: file.fileType,
            pathUrl: file.pathUrl,
            createdBy: file.createdBy.id,
          }
        }),
      }
    }
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapProsecutionActions(['getProsecutionDetail', 'updateProsecutionDetail', 'uploadFile', 'updateFile', 'createFile', 'deleteFile']),
    visibilityDel(file){
      return this.isRoot ||  file.createdBy === this.currentUser.id;
    },
    download(file) {
      const url = getUploadsUrl(file.fileName)
      window.open(url, '_blank');
    },
    openUrl(url) {
      window.open(url, '_blank');
    },
    async del(id) {
      const vm = this
      const {deleteFile} = vm
      vm.actionID = id
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: async () => {
          await deleteFile({
            form: {
              id
            },
            vm
          });
          const index = vm.form.files.findIndex(file => file.id === id)
          vm.form.files.splice(index, 1)
        }
      })
    },
    onFileChange(e) {
      this.selectedFile = e.target.files[0]; // accessing file;
    },
    async onUploadFile() {
      const vm = this
      const formData = new FormData();
      const {createFile} = vm;
      formData.append("file", vm.selectedFile);  // appending file
      const result = await vm.uploadFile({
        id: vm.$route.params.contractId,
        form: {
          formData: formData
        },
        vm
      });
      const file = await createFile({
        form: {
          contract: {id: vm.$route.params.contractId || ''},
          prosecution: {id: vm.$route.params.prosecutionId || ''},
          prosecutionDetail: null,
          fileFrom: IFileFrom.prosecution,
          description: vm.form.description,
          fileName: result.fileName,
          fileType: result.fileType,
          pathUrl: result.pathUrl
        },
        vm
      });
      vm.form.files.push({
        id: file.id,
        description: file.description,
        fileName: file.fileName,
        fileType: file.fileType,
        pathUrl: file.pathUrl,
        createdBy: file.createdBy.id,
      })
      vm.form.description = ""
      vm.selectedFile = null
      vm.$refs.inputFile.value = null
    }
  },
};
</script>

<style scoped>
.vx-coll-fixed-height{
  display:block;
  width:100%;
  height:555px;
  overflow: auto;
}
</style>
